import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Messages from '@common/components/Messages/Messages';
import RequestUserInfo from './Modals/RequestUserInfo/RequestUserInfo';
import LightboxSingle from '@common/components/LightboxSingle';
import AuthModal from './Modals/AuthModal/AuthModal';
import RegisterModalByLink from '@student/components/Modals/RegisterModalByLink';
import SchoolSubscription from '@student/components/Modals/SchoolSubscription';
import PdfViewerModal from '@common/components/PdfViewerModal.vue';
import CEmployeeCard from '@common/components/CEmployeeCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseGlobalModals',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(AuthModal)),
                _createVNode(_unref(RegisterModalByLink)),
                _createVNode(_unref(Messages)),
                _createVNode(_unref(RequestUserInfo)),
                _createVNode(_unref(LightboxSingle)),
                _createVNode(_unref(SchoolSubscription)),
                _createVNode(PdfViewerModal),
                _createVNode(CEmployeeCard)
            ]));
        };
    }
});
